// Weekly schedule maths for the availability view.
//
// The grid is 30-minute slots, 08:00–22:00, Monday–Sunday.
//   slot index  0 … 27        (s2m / m2s convert to and from minutes since midnight)
//   slot key    "thu-1530"    (how a person's free blocks are stored)
//   class block { id, cls, label?, day, start: "1530", end: "1630", room }
//
// Per-week overrides live in schedule.ex[weekMondayISO][blockId]:
//   an object → the block moved to that day/time for that week only
//   null      → the block is cancelled that week

export const AV_DAYS = [
  ["mon", "Mon"],
  ["tue", "Tue"],
  ["wed", "Wed"],
  ["thu", "Thu"],
  ["fri", "Fri"],
  ["sat", "Sat"],
  ["sun", "Sun"],
];
export const AV_DAYKEYS = AV_DAYS.map((x) => x[0]);

export const AV_START = 8 * 60;
export const AV_END = 22 * 60;
export const AV_STEP = 30;
export const AV_N = (AV_END - AV_START) / AV_STEP;

export const m2s = (m) => Math.round((m - AV_START) / AV_STEP);
export const s2m = (s) => AV_START + s * AV_STEP;

/** "1530" → 930 minutes */
export const hm2m = (t) => parseInt(t.slice(0, 2), 10) * 60 + parseInt(t.slice(2, 4), 10);

/** 930 → "1530" */
export const m2hm = (m) => String(Math.floor(m / 60)).padStart(2, "0") + String(m % 60).padStart(2, "0");

/** 930 → "3:30pm" */
export function tLabel(m) {
  const h = Math.floor(m / 60);
  const mm = m % 60;
  const ap = h < 12 ? "am" : "pm";
  const hh = h % 12 === 0 ? 12 : h % 12;
  return hh + (mm ? ":" + String(mm).padStart(2, "0") : "") + ap;
}

export const slotKey = (day, s) => day + "-" + m2hm(s2m(s));

export const blockName = (b) => b.label || b.cls;

/**
 * A person's blocks for a given week, with overrides applied.
 * @param {object} schedDoc  schedule/<personId>
 * @param {string} weekKey   "base" or a Monday ISO date
 */
export function effectiveBlocks(schedDoc, weekKey) {
  const sc = schedDoc || {};
  const base = sc.blocks || [];
  if (weekKey === "base") return base.slice();

  const ex = (sc.ex || {})[weekKey] || {};
  const out = [];
  for (const b of base) {
    if (Object.prototype.hasOwnProperty.call(ex, b.id)) {
      const o = ex[b.id];
      if (!o) continue; // cancelled this week
      out.push({ id: b.id, cls: b.cls, label: b.label, day: o.day, start: o.start, end: o.end, room: b.room, moved: true });
    } else {
      out.push(b);
    }
  }
  return out;
}

/** { "thu-14": true } for every slot this person is in class. */
export function busyMap(schedDoc, weekKey) {
  const map = {};
  for (const b of effectiveBlocks(schedDoc, weekKey)) {
    const a = m2s(hm2m(b.start));
    const z = m2s(hm2m(b.end));
    for (let s = a; s < z; s++) map[b.day + "-" + s] = true;
  }
  return map;
}

/**
 * Free means "marked free AND not in class".
 * Marking is recurring; class blocks vary by week — which is why this takes both.
 */
export function isFreeAt(availDoc, busy, day, s) {
  const slots = (availDoc && availDoc.slots) || [];
  return slots.indexOf(slotKey(day, s)) > -1 && !busy[day + "-" + s];
}
